import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  merchantIdTextfield: {
    marginTop: '1rem',
  },
  jsonTextArea: {
    marginTop: '1rem',
    minHeight: '6rem',
    padding: '0.25rem',
    fontSize: '1rem',
  },
  importButton: {
    marginTop: '1rem',
    backgroundColor: '#329BFC',
    fontFamily: 'Sora,sans-serif',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#FFFFFF',
    borderRadius: '4px',
    alignSelf: 'center',
    padding: '0.75rem 1.5rem',

    '&:hover': {
      backgroundColor: '#329BFC',
      opacity: 0.9,
    }
  }
}));
